import Empty from 'constants/empty';

const storeAndDeliveryFlyoutSelector = store => store.storeAndDeliveryFlyout || Empty.Object;

export { storeAndDeliveryFlyoutSelector };
